import { apiClient } from 'api'
import { LeagueFormat } from 'types/league-formats'

type NewItem = Omit<LeagueFormat, 'id'>

export const getLeagueFormats = () => apiClient.get<LeagueFormat[]>('/league-formats')

export const getLeagueFormatById = (id: number) => apiClient.get<LeagueFormat>(`/league-formats/${id}`)

export const createLeagueFormat = (item: NewItem) => apiClient.post<NewItem, LeagueFormat>('/league-formats', item)

export const editLeagueFormat = (item: LeagueFormat) =>
    apiClient.patch<LeagueFormat>(`/league-formats/${item.id}`, item)

export const deleteLeagueFormat = (id: number) => apiClient.delete(`/league-formats/${id}`)
